export default {
  searchICD11(q) {
    return fetch(`${process.env.VUE_APP_API_URL}/icd11/search/${q}`, {
      method: 'GET'
    })
      .then(res => {
        if (res.ok) {
          return res.json()
        }
      })
      .catch(err => {
        throw new Error(err.message)
      })
  }
}
